module.exports = __webpack_public_path__ + "assets/c.fc5854e5.svg";